import { render, staticRenderFns } from "./TabAsso.vue?vue&type=template&id=a97ecb14&"
import script from "./TabAsso.vue?vue&type=script&lang=js&"
export * from "./TabAsso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports